import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ProductDetailPage from "./ProductDetailPage";


export default function CheckID() {
    // get id from url params
    const { qr_id } = useParams();

    const [item, setItem] = useState(null);
    
    document.title = "Check Item - IMS";
    
    useEffect(() => {
        console.log("QR ID:", qr_id);
        window.localStorage.removeItem("qr_id");
        axios.get(`${process.env.REACT_APP_API_URL}/item`,
            { params: { qr_id },
        headers : {
            Authorization: `Bearer ${window.localStorage.getItem("token")}`
        } }
        )
            .then(response => {
                if(response.data.message === "Item not registered"){
                    window.localStorage.setItem("qr_id", qr_id);
                    window.location.href = '/product/new';
                }
                else if(response.data.message === "Item found"){
                    window.localStorage.setItem("qr_id", qr_id);
                    setItem(response.data.item);
                    console.log(response.data.item)
                    console.log("Item found, redirecting to product page");
                }
                
                //window.location.href = response.data ? `/product/${response.data.id}` : '/product/new';
            })
            .catch(error => {

                alert("Error fetching item data", error);
            });
    }, []);

    return (
        <>
            {item && <ProductDetailPage item={item} />}



        </>
    );
}